import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { TitrateConstants } from '../store/titrate.constants'
import { ITitrateState } from '../store/titrate.types'
import { getTitrateSelector } from '../selectors/titrate.selector'
import { IStringInput } from '../../../../components/stringInput/StringInput.component'
import { setUpdateInputRows } from '../store/titrate.actions'

export function* setMedication() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const titrateState: ITitrateState = yield select(getTitrateSelector)
  const { inputRows } = procedureState
  const { medication } = titrateState
  let updateInputRows = false
  inputRows.forEach((row) =>
    row.inputs.forEach((input) => {
      if (input.key === TitrateConstants.SET_OTHER_OPTION) {
        const StringInputProps = input.props as IStringInput
        if (medication && !StringInputProps.disabled) {
          StringInputProps.inputValue = ''
          StringInputProps.disabled = true
          updateInputRows = true
        } else if (!medication && StringInputProps.disabled) {
          StringInputProps.disabled = false
          updateInputRows = true
        }
      }
    })
  )
  if (updateInputRows) {
    yield put(setInputRows(inputRows))
    yield put(setUpdateInputRows(true))
  }
}

export function* setMedicationSaga() {
  yield takeLatest([TitrateConstants.SET_MEDICATION], setMedication)
}
